import { render, staticRenderFns } from "./ProfessionalTabs.vue?vue&type=template&id=06a2a452"
import script from "./ProfessionalTabs.vue?vue&type=script&lang=js"
export * from "./ProfessionalTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports